


































import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import WizardService from "@/services/wizardService";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepConnect",
  mixins: [wizardStepsMixin],
  data() {
    return {
      code: "",
    };
  },
  props: {
    update: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { VaButton },
  computed: {},
  methods: {
    onInput() {
      this.code = this.code.toUpperCase();
    },
    async connectToRoom() {
      try {
        this.loading = true;
        const configuration = await WizardService.connectToRoom(
          this.code,
          this.update
        );
        this.$emit("onFetchConfiguration", configuration);
        this.onNext();
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
  },
});
